import * as types from '../services/providerRequestActionType';
import initialState from '../../../../store/initialState';

const providerRequestInitialState = initialState.providerRequest;

const providerRequestReducer = (state = providerRequestInitialState, action) => {
    switch (action.type) {
        case types.FETCH_PROVIDER_REQUESTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case types.FETCH_PROVIDER_REQUESTS_SUCCESS:
            return {
                ...state,
                loading: false,
                list: Array.isArray(action.payload?.data) ? action.payload.data : [],
                recordsTotal: action.payload?.recordsTotal || 0,
            };
        case types.FETCH_PROVIDER_REQUESTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case types.FETCH_PROVIDER_REQUEST_DROPDOWNS_REQUEST:
            return {
                ...state,
                dropdowns: {
                    ...state.dropdowns,
                    loading: true,
                    error: null,
                },
            };
        case types.FETCH_PROVIDER_REQUEST_DROPDOWNS_SUCCESS:
            return {
                ...state,
                dropdowns: {
                    loading: false,
                    providers: action.payload?.Providers ?? action.payload?.providers ?? [],
                    requestTypes: action.payload?.RequestTypes ?? action.payload?.requestTypes ?? [],
                    tasks: action.payload?.Tasks ?? action.payload?.tasks ?? [],
                    taskLocations: action.payload?.TaskLocations ?? action.payload?.taskLocations ?? [],
                    statuses: action.payload?.Statuses ?? action.payload?.statuses ?? [],
                    recurrences: action.payload?.Recurrences ?? action.payload?.recurrences ?? [],
                    providerTypes: action.payload?.ProviderTypes ?? action.payload?.providerTypes ?? [],
                    error: null,
                },
            };
        case types.FETCH_PROVIDER_REQUEST_DROPDOWNS_FAILURE:
            return {
                ...state,
                dropdowns: {
                    ...state.dropdowns,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.UPDATE_PROVIDER_REQUEST_STATUS_REQUEST:
            return {
                ...state,
                statusMutation: { updating: true, error: null },
            };
        case types.UPDATE_PROVIDER_REQUEST_STATUS_SUCCESS:
            return {
                ...state,
                statusMutation: { updating: false, error: null },
            };
        case types.UPDATE_PROVIDER_REQUEST_STATUS_FAILURE:
            return {
                ...state,
                statusMutation: { updating: false, error: action.payload },
            };
        case types.BULK_UPDATE_PROVIDER_REQUEST_TASK_REQUEST:
            return {
                ...state,
                bulkTaskMutation: { saving: true, error: null },
            };
        case types.BULK_UPDATE_PROVIDER_REQUEST_TASK_SUCCESS:
            return {
                ...state,
                bulkTaskMutation: { saving: false, error: null },
            };
        case types.BULK_UPDATE_PROVIDER_REQUEST_TASK_FAILURE:
            return {
                ...state,
                bulkTaskMutation: { saving: false, error: action.payload },
            };
        case types.CHECK_PROVIDER_REQUEST_ADHOC_REQUEST:
            return {
                ...state,
                adhocCheck: { loading: true, data: null, error: null },
            };
        case types.CHECK_PROVIDER_REQUEST_ADHOC_SUCCESS:
            return {
                ...state,
                adhocCheck: { loading: false, data: action.payload, error: null },
            };
        case types.CHECK_PROVIDER_REQUEST_ADHOC_FAILURE:
            return {
                ...state,
                adhocCheck: { loading: false, data: null, error: action.payload },
            };
        case types.SAVE_PROVIDER_REQUEST_ADHOC_REQUEST:
            return {
                ...state,
                adhocSave: { saving: true, data: null, error: null },
            };
        case types.SAVE_PROVIDER_REQUEST_ADHOC_SUCCESS:
            return {
                ...state,
                adhocSave: { saving: false, data: action.payload, error: null },
            };
        case types.SAVE_PROVIDER_REQUEST_ADHOC_FAILURE:
            return {
                ...state,
                adhocSave: { saving: false, data: null, error: action.payload },
            };
        case types.SCHEDULE_REQUEST_TRANSACTION_REQUEST:
            return {
                ...state,
                scheduleRequestTransaction: {
                    loading: !action.payload?.request?.IsSave,
                    saving: Boolean(action.payload?.request?.IsSave),
                    data: null,
                    error: null,
                },
            };
        case types.SCHEDULE_REQUEST_TRANSACTION_SUCCESS:
            return {
                ...state,
                scheduleRequestTransaction: {
                    loading: false,
                    saving: false,
                    data: action.payload,
                    error: null,
                },
            };
        case types.SCHEDULE_REQUEST_TRANSACTION_FAILURE:
            return {
                ...state,
                scheduleRequestTransaction: { loading: false, saving: false, data: null, error: action.payload },
            };
        case types.SET_PROVIDER_REQUEST_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};

export default providerRequestReducer;
